import { apiClient } from './client.js';

export const workspaceApi = {
  get: () => apiClient.get('/workspace'),
  update: (payload) => apiClient.put('/workspace', payload),
  archive: () => apiClient.post('/workspace/archive'),
  delete: () => apiClient.delete('/workspace'),
  metrics: () => apiClient.get('/workspace/metrics'),
  members: () => apiClient.get('/workspace/members'),
  updateMember: (userId, role) => apiClient.patch(`/workspace/members/${userId}`, { role }),
  removeMember: (userId) => apiClient.delete(`/workspace/members/${userId}`),
  purge: () => apiClient.post('/workspace/purge'),
  exportData: () => apiClient.get('/workspace/export', { responseType: 'blob' }),
  importData: (json) => apiClient.post('/workspace/import', json, { headers: { 'Content-Type': 'application/json' } }),
  activity: (limit = 50) => apiClient.get('/workspace/activity', { params: { limit } }),
  listInvitations: () => apiClient.get('/invitations'),
  invite: (email, role) => apiClient.post('/invitations', { email, role }),
  acceptInvitation: (token) => apiClient.post('/invitations/accept', { token }),
};
